import { Component, OnInit, Input } from '@angular/core';
import { ToastController, NavController } from '@ionic/angular';

import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EventService } from 'src/app/services/api/event/event.service';
import { FunctionsService } from 'src/app/services/functions/functions.service';
import { AccessService } from 'src/app/services/access/access.service';
import { InstallationArea } from 'src/app/interfaces/installation';
import { DocumentReference } from '@angular/fire/firestore';
import { TerminalRelay, Terminal } from 'src/app/interfaces/terminal';

@Component({
  selector: 'app-relay',
  templateUrl: './relay.component.html',
  styleUrls: ['./relay.component.scss'],
})
export class RelayComponent implements OnInit {
  public cssClass = '';
  // tslint:disable-next-line:no-input-rename
  @Input('relay') relay: { name: string, relay: TerminalRelay, terminal: Terminal, open: boolean };
  data: string;
  public disabled = false;
  translations: any = {
    open: '',
    openingUp: '',
    welcome: '',
    enter: '',
    exit: ''
  };
  constructor(
    private funcService: FunctionsService,
    private eventServ: EventService,
    public translate: TranslateService,
    private accessServ: AccessService
  ) { }

  ngOnInit(
  ) {
    this.initTranslate();

  }

  initTranslate() {
    this.translate.get(
      [
        'OPENING.OPEN',
        'OPENING.OPENING_UP',
        'OPENING.WELCOME',
        'OPENING.ENTER',
        'OPENING.EXIT'
      ]).subscribe((values) => {
        // console.log(values);
        this.translations.open = values['OPENING.OPEN'] as unknown as string;
        this.translations.openingUp = values['OPENING.OPENING_UP'];
        this.translations.welcome = values['OPENING.WELCOME'];
        this.translations.enter = values['OPENING.ENTER'];
        this.translations.exit = values['OPENING.EXIT'];
        if (this.relay.relay.type === 'in'
          || this.relay.relay.type === 'in_resident'
          || this.relay.relay.type === 'in_parking'
          || this.relay.relay.type === 'in_guest') {
          this.cssClass = 'entry';
          this.data = this.translations.enter;
        } else if (this.relay.relay.type === 'out'
          || this.relay.relay.type === 'out_resident'
          || this.relay.relay.type === 'out_parking'
          || this.relay.relay.type === 'out_guest') {
          this.cssClass = 'exit';
          this.data = this.translations.exit;
        } else if (!this.relay.relay.type || this.relay.relay.type === 'none' || this.relay.relay.type === 'none_resident'
          || this.relay.relay.type === 'none_guest') {
          this.data = this.translations.open;
        }
      });
  }

  async relayOpen(relay) {
    this.disabled = true;
    this.data = this.translations.openingUp;
    /* const toast = await this.toastCtrl.create({
      message: `Petición de apertura : ${relay.name}`,
      duration: 2000
    });
    toast.present(); */
    // console.log(relay);
    this.openRelay(relay);
  }

  openRelay(relay) {
  //  // console.log(relay);
  //  // console.log(relay.terminal.areaRef);
  //  // console.log(relay.terminal.type);
  //  // console.log(this.accessServ.eventDetails);
    if (this.accessServ.eventDetails.access.type !== 'parking' && this.checkUsedAccess(
      this.accessServ.eventDetails.guest.accessAreas,
      relay.terminal.areaRef,
      relay.terminal.type)
    ) {
      this.funcService.showConfirm(
        '¿Abrir ' + relay.relay.name + '?',
        'Por cuestiones de seguridad recomendamos abrir el porton únicamente cuando se encuentre cerca de la entrada',
        'Cancelar', 'Abrir').then(
          r => {
            if (r) {
              this.funcService.present('Obteniendo informacion');
              this.eventServ.guestOpenRelay(
                this.accessServ.eventDetails.access.id,
                relay.terminal,
                relay.relay.id,
                this.accessServ.eventDetails.guest.acc)
                .subscribe(async res => {
                  // console.log(res);
                  this.funcService.dismiss();
                  
                  if (res['payload']['data']['guest']) {
                    
                    this.accessServ.eventDetails.guest = res['payload']['data']['guest'];
                  }
                  this.data = this.translations.welcome;
                  setTimeout(() => {
                    this.disabled = false;
                    this.data = this.translations.open;
                  }, 5000);
                }, async err => {
                  // console.log(err);
                  this.funcService.dismiss();
                  this.funcService.showAlert('Operación incompleta', `"${err.error.message}"`, 'ok');
                  setTimeout(() => {
                    this.disabled = false;
                    this.data = this.translations.open;
                  }, 5000);
                });
            } else {
              setTimeout(() => {
                this.disabled = false;
                this.data = this.translations.open;
              }, 1000);
            }
          }
        );
    } else if (this.accessServ.eventDetails.access.type === 'parking' && this.checkUsedAccess(
      this.accessServ.eventDetails.access.ticket.accessAreas,
      relay.terminal.areaRef,
      relay.terminal.type, true)
    ) {
      this.funcService.showConfirm(
        '¿Abrir ' + relay.relay.name + '?',
        'Por cuestiones de seguridad recomendamos abrir el porton únicamente cuando se encuentre cerca de la salida',
        'Cancelar', 'Abrir').then(
          r => {
            if (r) {
              this.funcService.present('Obteniendo informacion');
              this.eventServ.ticketOpenRelay(
                this.accessServ.eventDetails.access.id,
                relay.terminal,
                relay.relay.id)
                .subscribe(async res => {
                //  // console.log(res);
                  this.funcService.dismiss();
                  this.data = this.translations.welcome;
                  setTimeout(() => {
                    this.disabled = false;
                    this.data = this.translations.open;
                  }, 5000);
                }, async err => {
                //  // console.log(err);
                  this.funcService.dismiss();
                  this.funcService.showAlert('Operación incompleta', `"${err.error.message}"`, 'ok');
                  setTimeout(() => {
                    this.disabled = false;
                    this.data = this.translations.open;
                  }, 5000);
                });
            } else {
              setTimeout(() => {
                this.disabled = false;
                this.data = this.translations.open;
              }, 1000);
            }
          }
        );
    } else {
      this.funcService.showToast('El acceso ha sido usado en esta área');
      setTimeout(() => {
        this.disabled = false;
        this.data = this.translations.open;
      }, 5000);
    }
  }

  checkUsedAccess(
    accessAreas: { areaRef: DocumentReference, in: boolean, out: boolean }[],
    terminalAreaRef: DocumentReference, terminalType: string, parking?: boolean): boolean {
    let band = true;
    if (this.accessServ.eventDetails.guest && !this.accessServ.eventDetails.guest.uniqueUse) {
      return true;
    }
    accessAreas.forEach(a => {
    //  // console.log(a);
    //  // console.log(a.areaRef['f_']['path']['segments'][1]);
    //  // console.log(terminalAreaRef);
      if (parking) {
        
        if (a.areaRef['f_']['path']['segments'][6] === terminalAreaRef['_path']['segments'][1]) {
          if (terminalType === 'in' && a.in === true) {
          //  // console.log('inn');
            band = true;
          } else {
            if (terminalType === 'out' && a.out === true) {
            //  // console.log('out');
              band = true;
            }
          }
        }
      } else {
        
        if (a.areaRef['_path']['segments'][1] === terminalAreaRef['_path']['segments'][1]) {
          if (terminalType === 'in' && a.in === true) {
          //  // console.log('inn');
            band = true;
          } else {
            if (terminalType === 'out' && a.out === true) {
            //  // console.log('out');
              band = true;
            }
          }
        }
      }
    });
  //  // console.log(band);
    return band;
  }

}
